import { CPF_CHECK_SCENE } from '../constant';

const Statistics = Mach.requireModule('Statistics');
export const CID = 'c_waimai_c_overseas_ftj7f1qa';
export const ERROR_RESPONSE_LEFT_BUTTON_MC_CID = 'b_sailor_c_p99huvnm_mc';
export const ERROR_RESPONSE_RIGHT_BUTTON_MC_CID = 'b_sailor_c_t8nicm0a_mc';
export const ILLEGAL_VALUE = '-999';

interface Value {
  [key: string]: any;
}
const pv = (val: Value = {}) => {
  Statistics.pvm(CID, val, '', 'sailor_c');
};
const mv = (bid: string, val: Value = {}) => {
  Statistics.view(CID, bid, val, 'sailor_c');
};

const mc = (bid: string, val: Value = {}) => {
  Statistics.click(CID, bid, val, 'sailor_c');
};

const order = (bid: string, val: Value = {}) => {
  Statistics.order(CID, bid, val, 'sailor_c');
};

// 在该页面销毁前，只会上报一次mv
const orderStatusPageMVTrackCache: any = {};

export const mvOnlyOnce = (bid: string, val: Value = {}) => {
  if (orderStatusPageMVTrackCache[bid]) {
    return;
  }
  orderStatusPageMVTrackCache[bid] = true;
  Statistics.view(CID, bid, val);
};

const lx = {
  pd() {
    Statistics.pd();
  },
  mv(bid, val = {}) {
    mv(bid, val);
  },
  mc(bid, val = {}) {
    mc(bid, val);
  },
  orderConfirmPv(val) {
    pv(val);
  },
  // 准时保曝光、新版删除
  punctualMv() {
    mv('b_sailor_c_kz6564d5_mv');
  },
  // 准时保曝光、新版展开部分mv
  punctualTrickerMv(val) {
    mv('b_sailor_c_zeysjoqz_mv', val);
  },
  // 提单后封斋弹窗
  reportRamadanErrorMv(val) {
    mv('b_sailor_c_6umcpa1g_mv', val);
  },
  reportRamadanErrorMc(val) {
    mc('b_sailor_c_6umcpa1g_mc', val);
  },
  // 准时保出餐慢文案曝光mv
  punctualFoodSlowTitleMv(val) {
    mv('b_sailor_c_odhi4f6g_mv', val);
  },
  // 准时保曝光、新版展开部分mv
  punctualTrickerMc(val) {
    mc('b_sailor_c_zeysjoqz_mc', val);
  },
  // 准时保点击
  punctualMc() {
    mc('b_sailor_c_kz6564d5_mc');
  },
  // 超时弹窗曝光
  promisePopupMv(val) {
    mv('b_sailor_c_wm0qudry_mv', val);
  },
  // 准时保弹窗查看规则按钮点击
  promisePopupRuleMc(val) {
    mc('b_sailor_c_qcl9f3wk_mc', val);
  },
  // 准时保弹窗我知道了按钮点击
  promisePopupGotItMc(val) {
    mc('b_sailor_c_fbycuc9n_mc', val);
  },
  // 准时保关闭
  promisePopupCloseMc(val) {
    mc('b_sailor_c_sg66f8bd_mc', val);
  },
  // 准时保命中风控或者超过次数弹窗曝光
  punctualModalMv(val) {
    mv('b_sailor_c_1yebttu6_mv', val);
  },
  // 准时保弹窗点击
  punctualModalMc(val) {
    mc('b_sailor_c_1yebttu6_mc', val);
  },
  // 通用返回模块
  backMc(val) {
    mc('b_waimai_c_overseas_m3baokqr_mc', val);
  },
  // 商家打烊倒计时提醒
  shopRestPromptMv(val) {
    mv('b_waimai_c_overseas_w14cd87n_mv', val);
  },
  // 商家休息弹窗
  shopRestDialogMv(val) {
    mv('b_waimai_c_overseas_0zbbp6lr_mv', val);
  },
  // 地址模块 曝光
  addressAreaMv(val) {
    mv('b_waimai_c_overseas_nr8rzgmt_mv', val);
  },
  // 地址模块 点击
  addressAreaMc(val) {
    mc('b_waimai_c_overseas_nr8rzgmt_mc', val);
  },

  // 底部地址栏 曝光
  bottomAddressPromptMv(val) {
    mv('b_waimai_c_overseas_p61mnzsd_mv', val);
  },

  // 预计送达时间 曝光
  etaMv() {
    mv('b_waimai_c_overseas_ngayqv7b_mv');
  },

  // 预计送达时间异常提示条 曝光
  etaAbnormalMv(val) {
    mv('b_waimai_c_overseas_rzukev9n_mv', val);
  },
  // 定位较远提示 曝光
  addressLocationTipsMv() {
    mv('b_waimai_c_overseas_xa1zb34o_mv');
  },

  // 送达地址列表浮层  曝光
  addressListDialogMv(val) {
    mv('b_waimai_c_overseas_igj5z66j_mv', val);
  },

  // 送达地址列表浮层-超区弹窗 曝光
  addressOverstepDialogMv(val) {
    mv('b_waimai_c_overseas_drzdrm39_mv', val);
  },

  // 送达地址列表浮层-超区弹窗 点击
  addressOverstepDialogMc(val) {
    mc('b_waimai_c_overseas_drzdrm39_mc', val);
  },

  // 送达地址列表浮层-新增收货地址按钮 点击
  newAddressButtonMc(val) {
    mc('b_waimai_c_overseas_j1r9i2au_mc', val);
  },

  // 送达地址列表浮层-编辑按钮 点击
  editAddressButtonMc(val) {
    mc('b_waimai_c_overseas_cba64rh6_mc', val);
  },

  // 送达地址列表浮层-地址Item 曝光
  addressItemMv(val) {
    mv('b_waimai_c_overseas_g484044a_mv', val);
  },

  // 送达地址列表浮层-地址Item 曝光
  addressItemMc(val) {
    mc('b_waimai_c_overseas_g484044a_mc', val);
  },

  // 订单信息-贴士  曝光
  chargeTipsMv(val) {
    mv('b_sailor_c_1115bwlo_mv', val);
  },

  // 订单信息-贴士  点击
  chargeTipsMc(val) {
    mc('b_sailor_c_1115bwlo_mc', val);
  },

  // 餐具模块  曝光
  tablewareMv(val) {
    mv('b_waimai_c_overseas_8y9hin4t_mv', val);
  },

  // 餐具模块   点击
  tablewareMc(val) {
    mc('b_waimai_c_overseas_8y9hin4t_mc', val);
  },

  // 备注入口  曝光
  remarkEntranceMv() {
    mv('b_waimai_c_overseas_30n9k8rx_mv');
  },

  // 备注入口  点击
  remarkEntranceMc() {
    mc('b_waimai_c_overseas_30n9k8rx_mc');
  },

  // 备注弹窗  曝光
  remarkDialogMv() {
    mv('b_waimai_c_overseas_yhaxa7h1_mv');
  },

  // 底bar  曝光
  bottomBarMv(val) {
    mv('b_waimai_c_overseas_jbpnbksx_mv', val);
  },

  // 底bar支付按钮 点击
  bottomBarPayMc(val) {
    mc('b_waimai_c_overseas_58ihbcbc_mc', val);
  },

  // 提交订单页-校验弹窗  曝光
  submitCheckDialogMv(val) {
    const {
      remind_reason
    } = val ?? {};

    mv('b_waimai_c_overseas_idvtngxo_mv', val);

    switch (remind_reason) {
      case 4:
      case 10:
        // 我知道了/取消
        mv('b_sailor_c_p99huvnm_mv', val);
        // 继续下单
        mv('b_sailor_c_t8nicm0a_mv', val);
        break;

      default:
        break;
    }
  },

  // 订单提交成功BO事件
  submitOrderSuccess(val) {
    order('b_waimai__bo_3017052200010046', val);
  },
  // 提交按钮上优惠券浮层
  voucherPopupMv(val) {
    mv('b_sailor_c_78p0qr97_mv', val);
  },
  voucherPopupMc(val) {
    mc('b_sailor_c_78p0qr97_mc', val);
  },

  // 支付方式不匹配的 mv
  payNotMatchDialogMv() {
    mv('b_sailor_c_9hnev3ws_mv');
  },
  // 支付方式不匹配的 mc
  payNotMatchDialogMc() {
    mc('b_sailor_c_9hnev3ws_mc');
  },

  // 取消订单 mc
  cancelOrderDialogMc() {
    mc('b_sailor_c_3biaepmg_mc');
  },

  // 取消订单 mv
  cancelOrderDialogMv() {
    mv('b_sailor_c_3biaepmg_mv');
  },

  // 未绑定手机号 mv
  unbindPhoneNumberMv(val) {
    mv('b_sailor_c_aisgxlcr_mv', val);
  },

  // 支付方式为空 mv
  emptyPaymentMv(val) {
    mv('b_sailor_c_axrltbau_mv', val);
  },

  activity919DialogMv(val) {
    mv('b_sailor_c_wqesmyom_mv', val);
  },

  activity919DialogMc(val) {
    mc('b_sailor_c_wqesmyom_mc', val);
  },
  showVoucherMv(val) {
    mv('b_sailor_c_98zqxafx_mv', val);
  },
  // 送达备注点击
  remarkBtnMc(val) {
    mc('b_sailor_c_1c6uqyyy_mc', val);
  },
  // 送达备注模块曝光
  remarkMv(val) {
    mv('b_sailor_c_1c6uqyyy_mv', val);
  },
  // 送达备注弹窗mv
  remarkModalMv(val) {
    mv('b_sailor_c_331e74sa_mv', val);
  },
  // 送达备注弹窗mc
  remarkModalCloseMc(val) {
    mc('b_sailor_c_331e74sa_mc', val);
  },
  // 送达备注弹窗输入框mc
  remarkModalInputMc(val) {
    mc('b_sailor_c_dm6dugw8_mc', val);
  },
  // 送达备注弹窗输入框mc
  remarkModalSaveMc(val) {
    mc('b_sailor_c_00a7xg9j_mc', val);
  },
  // 大订单提示曝光
  largeOrderTipsMv(val) {
    mv('b_sailor_c_4zg4as28_mv', val);
  },
  clickTabMc(val) {
    mc('b_sailor_c_qoa14mgc_mc', val);
  },
  // 自取引流标签（气泡）
  clickTabMv(val) {
    mv('b_sailor_c_qoa14mgc_mv', val);
  },
  pickupMapMc(val) {
    mc('b_sailor_c_l8af8zxm_mc', val);
  },
  pickupMapMv(val) {
    mv('b_sailor_c_l8af8zxm_mv', val);
  },
  farAwayDialogMv() {
    mv('b_sailor_c_wcriokz2_mv');
  },
  clickPickupButtonCancelMc() {
    mc('b_sailor_c_wcriokz2_mc');
  },
  clickPickupButtonConfirmMc() {
    mc('b_sailor_c_o8g2skgn_mc');
  },
  // 最佳优惠提示曝光
  voucherFlowersMV() {
    mv('b_sailor_c_lnr8eibd_mv');
  },
  // 补差价弹窗曝光
  minCostDialogMv() {
    mv('b_sailor_c_hs8y7h34_mv');
  },
  // 补差价取消
  minCostDialogCancelBtnMc() {
    mc('b_sailor_c_hs8y7h34_mc', {
      button_name: 0,
    });
  },
  // 补差价确认
  minCostDialogOkBtnMc() {
    mc('b_sailor_c_hs8y7h34_mc', {
      button_name: 1,
    });
  },
  // 商品状态变更弹窗曝光
  productStatusChangeDialogMv() {
    mv('b_sailor_c_pycud1ru_mv');
  },
  // 商品状态变更知道了点击
  productStatusChangeDialogMc(val) {
    mc('b_sailor_c_pycud1ru_mc', val);
  },
  //缺货引导气泡曝光埋点
  outOfStockPopMv() {
    mvOnlyOnce('b_sailor_c_716juicg_mv');
  },
  //缺货引导气泡点击埋点
  outOfStockPopMc() {
    mc('b_sailor_c_716juicg_mc');
  },
  //缺货引导设置气泡点击关闭埋点
  OutOfStockPopCloseMc() {
    mc('b_sailor_c_1yicxf4f_mc');
  },
  //缺货设置曝光埋点
  outOfStockSetMv() {
    mvOnlyOnce('b_sailor_c_zfgvl227_mv');
  },
  //缺货设置点击埋点
  outOfStockSetMc() {
    mc('b_sailor_c_zfgvl227_mc');
  },
  //缺货浮层曝光埋点
  outOfStockLayerMv() {
    mvOnlyOnce('b_sailor_c_vrqqsxkg_mv');
  },
  //缺货浮层关闭按钮点击埋点
  outOfStockLayerCloseMc() {
    mc('b_sailor_c_l54e9ovg_mc');
  },
  //缺货浮层提交确认点击埋点
  outOfStockLayerConfirmMc() {
    mc('b_sailor_c_oms2ckmd_mc');
  },
  //缺货浮层缺货处理方案选择点击埋点
  outOfStockLayerOptionMc(val) {
    mc('b_sailor_c_h4adk82w_mc', val);
  },
  //缺货设置浮层默认下一单勾选点击埋点
  outOfStockLayerSaveMc() {
    mc('b_sailor_c_tlo3z8au_mc');
  },
  recommandAddressMv() {
    mv('b_sailor_c_67iivyls_mv');
  },
  recommandAddressMc() {
    mc('b_sailor_c_67iivyls_mc');
  },
  closeRecommandAddressMc() {
    mc('b_sailor_c_8ez09h5a_mc');
  },
  temporaryAddressDialogMv(val) {
    mv('b_sailor_c_5ikycab6_mv', val);
  },
  temporaryAddressDialogViewAddressMv(val) {
    mv('b_sailor_c_ee91azmc_mv', val);
  },
  temporaryAddressDialogAddAddressMv(val) {
    mv('b_sailor_c_wamolr2q_mv', val);
  },
  closeTemporaryAddressDialogMc(val) {
    mc('b_sailor_c_6rpaqp4h_mc', val);
  },
  temporaryAddressDialogClickOtherAddressMc(val) {
    mc('b_sailor_c_ee91azmc_mc', val);
  },
  temporaryAddressDialogClickAddAddressMc(val) {
    mc('b_sailor_c_wamolr2q_mc', val);
  },
  deliveryAddressMapMv(val) {
    mv('b_sailor_c_fsr32jl5_mv', val);
  },
  deliveryAddressMapMc(val) {
    mc('b_sailor_c_fsr32jl5_mc', val);
  },
  cpfInfoMv(val) {
    mv('b_sailor_c_n1g132im_mv', val);
  },
  cpfInfoMc(val) {
    mc('b_sailor_c_n1g132im_mc', val);
  },
  cpfInputMv(val) {
    mv('b_sailor_c_1fvt5k20_mv', val);
  },
  cpfInputMc(required, operationType, checkScene?) {
    mc('b_sailor_c_1fvt5k20_mc', {
      input_box_state: (checkScene === CPF_CHECK_SCENE.SAFETY_CHECK || required) ? 2 : 1,
      operation_type: operationType,
      required_reason: (checkScene === CPF_CHECK_SCENE.SAFETY_CHECK ? 2 : (required ? 1 : -1)),
    });
  },
  // 调整菜品入口
  adjustFoodEntranceMv() {
    mv('b_sailor_c_ijo9izvv_mv');
  },
  adjustFoodEntranceMc() {
    mc('b_sailor_c_ijo9izvv_mc');
  },
  // 慢问题-异常提示文案曝光
  errorDeliveryTipMv(val) {
    mv('b_sailor_c_cqrs61iy_mv', val);
  },
  // 现金准备检查弹窗曝光
  prepareCashCheckDialogMv() {
    mv('b_sailor_c_tkwx8jag_mv');
  },
  // 现金准备检查弹窗点击
  prepareCashCheckDialogMc(val) {
    // todo 替换bid
    mc('b_sailor_c_w555t8cv_mc', val);
  }
};

export default lx;
